import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js';
import { createStripeCheckoutSession } from './createStripeCheckoutSession';
import { validateCheckout } from './validateCheckout';
import { useRetriggerFlowDataFetch } from '../../Context/FlowDataProvider';

const stripeLivePromise = loadStripe(
  'pk_live_51N7uVbSDNVZkOnSKcWhGEe0OQPSrYWFGFmD8VHedGc0pm7DCycecXSPIN5wahmxTa1g8hDxBiIO0lkdKk3EDfmt700rgUcMWS9'
);

// const stripeTestPromise = loadStripe(
//   'pk_test_51N7uVbSDNVZkOnSKz0DD9gH9utuXd52YySeeFBBlIgMFbHim70ZDZrK4h6bNF3cN7r3aZJ9o8GAsAhsQJwnjcwzV00b870S4Q6'
// );

// const stripePromise = loadStripe(
//   localStorage.getItem('devmode') === 'true'
//     ? 'pk_test_51N7uVbSDNVZkOnSKz0DD9gH9utuXd52YySeeFBBlIgMFbHim70ZDZrK4h6bNF3cN7r3aZJ9o8GAsAhsQJwnjcwzV00b870S4Q6'
//     : 'pk_live_51N7uVbSDNVZkOnSKcWhGEe0OQPSrYWFGFmD8VHedGc0pm7DCycecXSPIN5wahmxTa1g8hDxBiIO0lkdKk3EDfmt700rgUcMWS9'
// );

export const StripeCheckoutForm: React.FC = () => {
  const retriggerFlowDataFetch = useRetriggerFlowDataFetch();
  return (
    <div id="checkout">
      <EmbeddedCheckoutProvider
        stripe={stripeLivePromise}
        options={{
          fetchClientSecret: () => createStripeCheckoutSession('blueprint'),
          onComplete: () => {
            validateCheckout('blueprint').then((isValid) => {
              if (isValid) {
                retriggerFlowDataFetch();
              }
            });
          },
        }}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
};
